import React from 'react'
import { Bug, Feedback } from '@yy/one-icon'
import type { ITypes } from '../../../Context'
import { useTranslation } from '../../../hooks'
import styles from './index.module.less'

const datas = [
  {
    Icon: <Bug />,
    // title: '报告错误',
    title: 'feedback.bug.title',
    // desc: `让我们知道哪里出了问题`,
    desc: `feedback.bug.desc`,
    type: 'bug',
  },
  {
    Icon: <Feedback />,
    // title: '改进建议',
    // desc: `我们如何可以改进`,
    title: 'feedback.improvment.title',
    desc: 'feedback.improvment.desc',
    type: 'feature',
  },
] as Array<{
  Icon: React.ReactElement
  title: string
  desc: string
  type: ITypes
}>

const List: React.FC<{
  onClick?: (type: ITypes) => void
}> = ({ onClick }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.list}>
      {datas.map(({ type, Icon, title, desc }, index) => {
        return (
          <div className={styles.item} onClick={() => onClick?.(type)} key={index}>
            {React.cloneElement(Icon, { className: styles.icon })}
            <div className={styles.content}>
              <div className={styles.title}>{t(title)}</div>
              <div className={styles.desc}>{t(desc)}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default List
